export async function discardBody(
  body: AsyncIterable<Uint8Array>,
  maxBytes: number,
): Promise<{ bytesRead: number; truncated: boolean }> {
  let bytesRead = 0;
  let truncated = false;

  for await (const chunk of body) {
    bytesRead += chunk.byteLength;
    if (bytesRead > maxBytes) {
      truncated = true;
      break;
    }
  }

  return { bytesRead, truncated };
}
